import { useCallback } from 'react';

const useContactUtils = () => {
  const formatContactPhone = useCallback((mobilePhoneNumber: string) => {
    const blankMobilePhone = mobilePhoneNumber.replace(/[()\s-]/g, '');
    return blankMobilePhone.replace(/^(?!\+)(.*)$/, '+$1');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { formatContactPhone };
};

export default useContactUtils;
